import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useState, useEffect, createContext, useContext } from 'react';
import { useLocation } from 'react-router-dom';
/** location state の key */
export const PREV_PATH_CONTEXT_LOCATION_STATE_KEY = 'from';
/**
 * 遷移前ページの path を管理する Context
 */
const Context = createContext('');
/**
 * Context を使用するための Hook
 */
export const usePrevPathContext = () => useContext(Context);
/**
 * Context を使用するための Provider
 */
export const PrevPathContextProvider = (props) => {
    const { children } = props;
    const location = useLocation();
    const [prevPath, setPrevPath] = useState(() => { var _a; return ((_a = location.state) === null || _a === void 0 ? void 0 : _a[PREV_PATH_CONTEXT_LOCATION_STATE_KEY]) || ''; });
    useEffect(() => {
        var _a;
        // すでに値が設定されている場合は何もしない
        if (prevPath) {
            return;
        }
        // 前のページのパスを取得
        const previousPath = ((_a = location.state) === null || _a === void 0 ? void 0 : _a[PREV_PATH_CONTEXT_LOCATION_STATE_KEY]) || '';
        setPrevPath(previousPath);
    }, [location, prevPath]);
    return _jsx(Context.Provider, Object.assign({ value: prevPath }, { children: children }));
};
